import React from "react";
import { Col, Container, Row } from "reactstrap";

function AwardsPage() {
  // const size = document.body.clientWidth >= 1024 || document.documentElement.clientWidth >= 1024 ? true : false;
  return (
    <>
      <div
        style={{
          overflow: "hidden",
          background: "transparent",
        }}
        className="section pb-2"
      >
        <Container fluid>
          <Container>
            <Row>
              <Col lg={6} className={``}>
                <h4 className=" text-700 text-white">
                  At <b>Exibex</b>, we take immense pride in celebrating the visionaries,
                  disruptors, and trailblazers who are revolutionizing the financial landscape. The
                  Finnovex Qatar Awards 2026 will spotlight the pioneers driving real,
                  transformative change—those who are not just embracing innovation but setting new
                  benchmarks for excellence in the industry.
                  <br />
                  <br />
                  By honoring the game-changers shaping the future of banking and finance, the
                  Finnovex Qatar Awards ignite a culture of ambition, pushing organizations and
                  individuals to challenge the status quo and drive sustainable growth.
                  <br />
                  <br />
                  With great admiration, we celebrate those who are breaking barriers, redefining
                  industry standards, and leading financial services into the future. The Finnovex
                  Qatar Awards 2026 are more than recognition—they stand as a testament to
                  collaboration, transformation, and the relentless pursuit of excellence.
                </h4>
                <br />
              </Col>
              <Col lg={6} className={`mb-3 `}>
                <img
                  src={require("assets/images/awards/DSC_0435.JPG")}
                  width="100%"
                  alt="awards"
                  style={{
                    borderRight: "10px solid #c0dea7",
                    borderTop: "10px solid #c0dea7",
                  }}
                />
              </Col>

              {content.map((data, index) => (
                <Col lg={3} key={index} className="stat-div border">
                  <div className="d-flex align-items-center" style={{ minHeight: "125px" }}>
                    <h5 className="text-700 mt-0 text-white">{data}</h5>
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </Container>
      </div>
    </>
  );
}

export default AwardsPage;

const content = [
  "Excellence in Mobile Banking",
  "Excellence in Digital Banking",
  "Excellence in Fintech",
  "Excellence in Payments",
  "Excellence in Cybersecurity",
  "Excellence in Customer Experience Enhancement",
  "Excellence in InsurTech",
  "Excellence in Open Banking",
  "Excellence in Cloud Banking",
  "Outstanding Contribution to Financial Inclusion Initiative",
  "Outstanding Contribution to Strategic National Development Initiatives",
  "Outstanding Contribution to Fintech Initiatives",
  "Finnovator of the Year, Qatar",
  "Influencer of the Year, Qatar",
  "Financial Women Trailblazer of the Year",
  "CEO of the Year",
  "COO of the Year",
  "CDO of the Year",
  "CIO of the Year",
  "CTO of the Year",
  "CFO of the Year",
  "CISO of the Year",
];
